import { useTranslator } from "components/Translator"
import { Section } from "components/Section"
import { Text } from "components/Text"

export const BoatDescription = (props) => {
  const { boat } = props
  const translator = useTranslator()

  return boat?.description ? (
    <Section
      title={translator.trans("BoatDescription.title", null, "components")}
      id="boat-description-title"
    >
      <Text
        variant="body2"
        className="bg-white px-5 py-4"
        aria-labelledby="boat-description-title"
      >
        {boat.description}
      </Text>
    </Section>
  ) : null
}
